<template>
  <div class="animated fadeIn">
    <div class="page-card-margin row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>Editar Perfil</strong>
          </div>
          <div class="card-block">
            <form id="user-form" class="form-horizontal" action="">
              <div class="row">
                <div class="form-group col-md-4">
                  <label class="form-control-label">Name</label>
                  <input class="form-control" name="name" placeholder="Name" v-model="name">
                </div>
                <div class="form-group col-md-4">
                  <label class="form-control-label">Surnames</label>
                  <input class="form-control" name="surnames" placeholder="Surnames" v-model="surnames">
                </div>
                <div class="form-group col-md-4">
                  <label class="form-control-label">Charge</label>
                  <input class="form-control" name="charge" placeholder="Charge" v-model="charge">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="form-control-label">Phone</label>
                  <input class="form-control" name="phone" placeholder="Phone" v-model="phone">
                </div>
                <div class="form-group col-md-6">
                  <label class="form-control-label">Email</label>
                  <input class="form-control" name="email" placeholder="Email" v-model="email">
                </div>
              </div>
              <div class="form-actions">
                <button type="button" class="btn btn-primary" @click="personalizeUser()">Edit User</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>Canviar Constrasenya</strong>
          </div>
          <div class="card-block">
            <form id="login-form" class="form-horizontal" action="">
              <div class="row">
                <div class="form-group col-md-4">
                  <label class="form-control-label">Password</label>
                  <input type="password" class="form-control" name="password" placeholder="Password" v-model="password">
                </div>
                <div class="form-group col-md-4">
                  <label class="form-control-label">Repeat Password</label>
                  <input type="password" class="form-control" name="password_confirmation" placeholder="Repeat Password"
                         v-model="password_confirmation">
                </div>
              </div>
              <div class="form-actions">
                <button type="button" class="btn btn-primary" @click="changePassword()">Change Password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Profile';
  import trans_es from '../translates/es/Profile';
  import middleware from "../utilities/middlewares";
  import constants from '../constants'

  export default {
    name: '',
    data() {
      return {
        web_texts: '',
        name: '',
        surnames: '',
        charge: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    },
    created() {
      window.localStorage.setItem('real_time_control', '["profile","profile"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      this.getUser();
    },
    methods: {
      // Llegir les dades del usuari
      getUser() {
        axios.post(constants.ROOT_URL + '/api/v1/get_user')
          .then((response) => {
            window.localStorage.setItem('user', JSON.stringify(response.data));
            this.name = response.data.name;
            this.surnames = response.data.surnames;
            this.charge = response.data.charge;
            this.phone = response.data.phone;
            this.email = response.data.email;

          }, (response) => {
            console.log(response.data);
            this.tokenValidCalls(response, this);
          });
      },
      // Editar l'usuari
      personalizeUser() {
        var formData = new FormData(document.getElementById("user-form"));
        axios.post(constants.ROOT_URL + '/api/v1/edit_user_by_user', formData)
          .then((response) => {
            console.log(response.data)
            this.getUser();
          }, (response) => {
            console.log(response.data)
          });
      },
      // Cambiar contrasenya
      changePassword() {
        var out=this;
        axios.post(constants.ROOT_URL + '/api/v1/change_user_password', {
          'password': this.password,
          'password_repeat': this.password_confirmation
        }).then(function (res) {
          if (res.data === "Passwords not mach"){
            console.log(res);
            swal({type: 'error', title: 'No Coincidents'})

          }else if(res.data === "Passwords Short") {
            console.log(res);
            swal({type: 'error', title: 'Massa Curta'})

          } else {
            swal({type: 'success', title: 'Fet!'})
            out.password = null;
            out.password_confirmation = null;

          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Profile.vue?3f8abb6b